<div class="modal-main">
  <div class="header w-100 pt-3">
    <div class="d-flex justify-content-between">
      <div class="profile-header-title d-flex flex-column justify-content-center">
        <span class="col-5 user-title m-auto text-center">
          <app-with-tooltip [showHelpCursor]="true">
            {{ this.formInstance?.name?.value }}
          </app-with-tooltip></span
        >
        <span class="modal-title m-auto">
          {{ "USER_PROFILE" | translate }}
        </span>
      </div>
      <span class="profile-header-close d-flex flex-row align-items-center justify-content-center">
        <img
          src="/assets/svg/ico-hamburger-white-close.svg"
          class="cross-button pointer-cursor pr-4"
          (click)="closeDialog()"
        />
      </span>
    </div>
    <div
      class="d-flex flex-column justify-content-center align-items-center user-profile"
    >
      <div class="profile-status-container">
        <app-profile-picture
          [name]="profileDetails?.name"
          [userData]="profileDetails"
          [font]="'large'"
        >
        </app-profile-picture>
        <span class="profile-avatar-status pending-access-icon" *ngIf="userStatus === 'pendingAccess'" aria-hidden="true">
          <svg viewBox="0 0 24 24" focusable="false">
            <circle cx="12" cy="12" r="8.5" />
            <circle cx="8.5" cy="12" r=".8" />
            <circle cx="12" cy="12" r=".8" />
            <circle cx="15.5" cy="12" r=".8" />
          </svg>
        </span>
        <span class="profile-avatar-status fob-access-icon" *ngIf="userStatus === 'fobAccess'" aria-hidden="true">
          <svg viewBox="0 0 24 24" focusable="false">
            <circle cx="12" cy="12" r="8" />
            <circle cx="12" cy="12" r="4.5" />
            <circle cx="12" cy="12" r="1.3" />
          </svg>
        </span>
        <span class="profile-avatar-status active-status-icon" *ngIf="userStatus === 'active'" aria-hidden="true">
          <svg viewBox="0 0 24 24" focusable="false">
            <circle cx="12" cy="12" r="12" fill="#53bf1d" />
            <path d="M6.5 12.3l3.6 3.6 7.5-8" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </span>
        <img *ngIf="statusIconPath" [src]="statusIconPath" alt="" class="profile-avatar-status" />
      </div>
      <!-- <img
    *ngIf="getNotExpiredTempRecords?.length > 0"
    src="assets/images/circle-time-red-trimmy.png"
    class="time"
    alt="circle-time-red"
  /> -->
    </div>
  </div>
  <div class="profile-status-wrapper" [ngClass]="'status-' + userStatus" role="status">
    <span class="profile-status-pill">{{ statusTranslationKey | translate }}</span>
  </div>
  <div class="container user-detail px-4 mx-3 pt-4 mb-2">
    <div
      *ngIf="
        userStatus === 'pendingActivation' &&
        loginUser?.userType === 'Property Manager Admin'
      "
    >
      <div class="invitation-warning-block">
        <div class="invitation-warning-row">
          <div class="icon-wrapper">
            <img
              src="assets/svg/resend-invite-ellipse.svg"
              class="ellipse"
              alt="Ellipse"
            />
            <img src="assets/svg/ico-alert-red.svg" class="alert" alt="Alert" />
          </div>

          <div class="info-container">
            <span class="info-text">
              {{ "ACCOUNT_NOT_ACTIVATED" | translate }}
            </span>
            <br />
            <button (click)="navigateToResendInvitation()" class="resend-link">
              {{ "Resend_Invitaion" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      *ngIf="userStatus === 'pendingDeletion'"
      class="deactivation-warning-block"
    >
      <div class="deactivation-warning-row">
        <div class="icon-wrapper">
          <img
            src="assets/svg/resend-invite-ellipse.svg"
            class="ellipse"
            alt="Ellipse"
          />
          <img src="assets/svg/ico-alert-red.svg" class="alert" alt="Alert" />
        </div>
        <div class="deactivation-warning-text">
          <span *ngIf="showPmuDisplayMessage(); else defaultDeletionMsg">
            {{
              "ACCOUNT_SCHEDULED_DELETION_PMU"
                | translate : { date: formattedAutoDeactivationDate }
            }}
          </span>
          <ng-template #defaultDeletionMsg>
            <span>
              {{
                "ACCOUNT_SCHEDULED_DELETION"
                  | translate : { date: formattedAutoDeactivationDate }
              }}
            </span>
          </ng-template>
          <ng-container *ngIf="showReviewDelete()">
            <br />
            <span
              class="review-request-link"
              (click)="navigateToPendingDeletion()"
            >
              {{ "REVIEW_REQUEST" | translate }}
            </span>
          </ng-container>
        </div>
      </div>
    </div>
    <div *ngIf="hideAccessForUnassignedPendingAccess" class="pending-access-notice">
      <img src="assets/svg/ico-info-blue.svg" alt="" />
      <span>{{ 'PROFILE_POPUP_PENDING_ACCESS_NOTICE' | translate }}</span>
    </div>
    <div *ngIf="userStatus === 'pendingAccess' && hasUserType" class="pending-access-notice">
      <img src="assets/svg/ico-info-blue.svg" alt="" />
      <span>{{ 'PROFILE_POPUP_PENDING_ACCESS_ASSIGNED_NOTICE' | translate }}</span>
    </div>
    <div class="child-container">
      <form
        *ngIf="profileDetails"
        [formGroup]="formGroup"
        class="mt-2 pt-2"
        (ngSubmit)="submit()"
      >
        <div class="row mt-3 mb-3 profile-section-heading">
          <div class="col heading pl-1">{{ "PROFILE" | translate }}</div>
          <button *ngIf="canEditFullProfile" type="button" class="profile-edit-link" (click)="openProfileEdit('profile')">{{ 'EDIT' | translate }}</button>
        </div>
        <div class="group-container">
          <div class="form-group rounded-top form-container">
            <mat-form-field appearance="fill" class="w-100 list-container primary-input bottom-zero padding-top-balance first">
              <div class="d-flex justify-content-between list-box">
                <div class="title">{{ "NAME" | translate }}</div>
                <div class="col-7 selected-value ml-auto text-right text-height mt-1"><p>{{ formInstance?.name?.value }}</p></div>
              </div>
              <input matInput formControlName="name" class="d-none" />
            </mat-form-field>
          </div>
        </div>
        <div class="group-container">
          <div class="form-group rounded-top form-container">
            <mat-form-field appearance="fill" class="w-100 list-container primary-input bottom-zero padding-top-balance middle">
              <div class="d-flex justify-content-between list-box">
                <div class="title">{{ "ACCESS_DETAIL_EMAIL" | translate }}</div>
                <div class="email ml-auto text-right"><p>{{ email || ('PROFILE_POPUP_NOT_SET' | translate) }}</p></div>
              </div>
              <input matInput formControlName="email" class="d-none" />
            </mat-form-field>
          </div>
        </div>
        <div class="group-container">
          <div class="form-group rounded-top form-container">
            <mat-form-field appearance="fill" class="w-100 list-container primary-input bottom-zero padding-top-balance middle">
              <div class="d-flex justify-content-between list-box">
                <div class="title">{{ "PHONE_NUMBER" | translate }}</div>
                <div class="selected-value ml-auto text-right"><p>{{ formInstance?.phone?.value || ('PROFILE_POPUP_NOT_SET' | translate) }}</p></div>
                <button type="button" *ngIf="!canEditFullProfile && canEditPhone" class="field-edit-btn" (click)="openProfileEdit('phone')" [attr.aria-label]="'PROFILE_POPUP_EDIT_PHONE' | translate"><img src="assets/svg/ico-edit.svg" alt="" /></button>
              </div>
              <input matInput formControlName="phone" class="d-none" />
            </mat-form-field>
          </div>
        </div>
        <div class="group-container mb-1">
          <div class="form-group rounded-top form-container">
            <mat-form-field appearance="fill" class="w-100 list-container primary-input bottom-zero padding-top-balance last">
              <div class="d-flex justify-content-between list-box">
                <div class="title">{{ "NOTES" | translate }}</div>
                <div class="selected-value ml-auto text-right notes-value" [class.notes-with-view-more]="hasNotesContent && notesOverflow && !notesExpanded">
                  <p #notesText [class.notes-collapsed]="!notesExpanded">{{ formInstance?.notes?.value || ('PROFILE_POPUP_NOT_SET' | translate) }}</p>
                  <button *ngIf="hasNotesContent && notesOverflow && !notesExpanded" type="button" class="notes-view-more" (click)="notesExpanded = true" [attr.aria-expanded]="notesExpanded">{{ 'VIEW_MORE' | translate | lowercase }}</button>
                </div>
                <button type="button" *ngIf="!canEditFullProfile" class="field-edit-btn" (click)="openProfileEdit('notes')" [attr.aria-label]="'PROFILE_POPUP_EDIT_NOTES' | translate"><img src="assets/svg/ico-edit.svg" alt="" /></button>
              </div>
              <input matInput formControlName="notes" class="d-none" />
            </mat-form-field>
          </div>
        </div>

        <ng-container *ngIf="!hideAccessForUnassignedPendingAccess">
        <div class="row mt-4 mb-3">
          <div class="col-7 heading pl-1">{{ "ACCESS_ACTIVITY" | translate }}</div>
        </div>

        <div class="group-container">
          <div class="form-group rounded-top form-container">
            <mat-form-field
              appearance="fill"
              class="w-100 list-container primary-input bottom-zero padding-top-balance first"
            >
              <div class="d-flex justify-content-between list-box pb-3">
                <div class="title">
                  <img class="mr-2 ml-1" [src]="FORM_ICONS.USER_TYPE" />
                  {{ "USER_TYPE" | translate }}
                </div>
                <div
                  class="selected-value ml-auto text-right align-self-center"
                >
                  <p class="m-0">
                    {{ formInstance?.userType?.value | translate }}
                  </p>
                </div>
              </div>
              <input
                matInput
                [placeholder]="'USER_TYPE' | translate"
                formControlName="userType"
                class="d-none"
              />
            </mat-form-field>
          </div>
        </div>
        <div class="group-container">
          <div class="form-group rounded-top form-container">
            <mat-form-field
              appearance="fill"
              class="w-100 list-container primary-input bottom-zero padding-top-balance middle pointer-cursor"
            >
              <div
                class="d-flex justify-content-between list-box"
                (click)="
                  formInstance?.userType?.value ===
                    CONSTANTS.PROPERTY_MANAGER_ADMIN ||
                  formInstance?.userType?.value ===
                    CONSTANTS.PROPERTY_MANAGER_USER
                    ? null
                    : navigateToUserGroups()
                "
              >
                <div class="title col-4 pt-0 align-self-center">
                  <img class="mr-1" [src]="FORM_ICONS.USER_GROUP" />
                  {{ "GROUP" | translate }}
                </div>

                <ng-container
                  *ngIf="
                    formInstance?.userType?.value ===
                      CONSTANTS.PROPERTY_MANAGER_ADMIN ||
                      formInstance?.userType?.value ===
                        CONSTANTS.PROPERTY_MANAGER_USER;
                    else elseRoleMismatchGroup
                  "
                >
                  <!-- Content to be shown when the condition is true -->
                  <div
                    class="selected-value ml-auto text-right align-self-center"
                  >
                    <p>{{ "ALL_ACCESS" | translate }}</p>
                  </div>
                </ng-container>

                <ng-template #elseRoleMismatchGroup>
                  <!-- Content to be shown when the condition is false -->
                  <div
                    class="selected-value ml-auto mt-1 text-right col-6 pt-0 align-self-center"
                  >
                    <span class="selected-value-text text-height">
                      <app-with-tooltip [showHelpCursor]="true">
                        {{ formInstance?.userGroups?.value }}
                      </app-with-tooltip>
                    </span>
                  </div>
                  <div class="btn-list mt-1">
                    <button
                      mat-icon-button
                      type="button"
                      aria-label="phone"
                      class="text-right"
                      tabindex="-1"
                    >
                      <mat-icon>arrow_forward_ios</mat-icon>
                    </button>
                  </div>
                </ng-template>
              </div>
              <input
                matInput
                [placeholder]="'USER_GROUPS' | translate"
                formControlName="userGroups"
                class="d-none"
              />
            </mat-form-field>
          </div>
        </div>
        <div class="group-container">
          <div class="form-group rounded-top form-container">
            <mat-form-field
              appearance="fill"
              class="w-100 list-container primary-input bottom-zero padding-top-balance middle pointer-cursor"
            >
              <div
                class="d-flex justify-content-between list-box"
                (click)="
                  formInstance?.userType?.value ===
                    CONSTANTS.PROPERTY_MANAGER_ADMIN ||
                  formInstance?.userType?.value ===
                    CONSTANTS.PROPERTY_MANAGER_USER
                    ? null
                    : navigateToUserAccess()
                "
              >
                <div class="title ml-1">
                  <img class="mr-3" [src]="FORM_ICONS.USER_ACCESS" />
                  {{ "ACCESS" | translate }}
                </div>

                <ng-container
                  *ngIf="
                    formInstance?.userType?.value ===
                      CONSTANTS.PROPERTY_MANAGER_ADMIN ||
                      formInstance?.userType?.value ===
                        CONSTANTS.PROPERTY_MANAGER_USER;
                    else elseRoleMismatch
                  "
                >
                  <!-- Content to be shown when the condition is true -->
                  <div class="selected-value ml-auto text-right">
                    <p>{{ "ALL_ACCESS" | translate }}</p>
                  </div>
                </ng-container>

                <ng-template #elseRoleMismatch>
                  <!-- Content to be shown when the condition is false -->
                  <div class="selected-value ml-auto text-right">
                    <p>
                      {{ formInstance?.userAccess?.value }}
                    </p>
                  </div>
                  <div class="btn-list">
                    <button
                      mat-icon-button
                      type="button"
                      aria-label="phone"
                      class="text-right"
                      tabindex="-1"
                    >
                      <mat-icon>arrow_forward_ios</mat-icon>
                    </button>
                  </div>
                </ng-template>
              </div>
              <input
                matInput
                [placeholder]="'ACCESS' | translate"
                formControlName="userAccess"
                class="d-none"
              />
            </mat-form-field>
          </div>
        </div>

        <div class="group-container">
          <div class="form-group rounded-top form-container">
            <mat-form-field
              appearance="fill"
              class="w-100 list-container primary-input bottom-zero padding-top-balance last pointer-cursor"
            >
              <div
                class="d-flex justify-content-between list-box"
                (click)="navigateToUserActivity()"
              >
                <div class="title">
                  <img class="mr-2" [src]="FORM_ICONS.USER_ACTIVITY" />
                  {{ "USER_ACTIVITY" | translate }}
                </div>
                <div class="last-activity ml-auto text-right">
                  <p>
                    {{ formInstance?.userActivity?.value || "" }}
                  </p>
                </div>
                <div class="btn-list">
                  <button
                    mat-icon-button
                    type="button"
                    aria-label="phone"
                    class="text-right"
                    tabindex="-1"
                  >
                    <mat-icon>arrow_forward_ios</mat-icon>
                  </button>
                </div>
              </div>
              <input
                matInput
                [placeholder]="'USER_ACTIVITY' | translate"
                formControlName="userActivity"
                class="d-none"
              />
            </mat-form-field>
          </div>
        </div>

        <div class="row mt-4 mb-3">
          <div class="col-7 heading pl-1">{{ "CREDENTIALS" | translate }}</div>
        </div>
        <div class="group-container">
          <div class="form-group rounded-top form-container">
            <mat-form-field appearance="fill" class="w-100 list-container primary-input bottom-zero padding-top-balance first pointer-cursor">
              <div class="d-flex justify-content-between list-box" [class.pointer-cursor]="canEditFullProfile" (click)="canEditFullProfile ? navigateToMobileAccess() : null">
                <div class="title pl-1"><mat-icon class="mobile-access-icon">phone_iphone</mat-icon>{{ 'MOBILE_ACCESS' | translate }}</div>
                <div class="selected-value mobile-access-status ml-auto text-right"><p>{{ mobileCredentialStatusKey | translate }}</p></div>
                <div class="btn-list" *ngIf="canEditFullProfile"><button mat-icon-button type="button" aria-label="Mobile Access" tabindex="-1"><mat-icon>arrow_forward_ios</mat-icon></button></div>
              </div>
              <input matInput formControlName="mobileCredential" class="d-none" />
            </mat-form-field>
          </div>
        </div>

        <div class="group-container">
          <div class="form-group rounded-top form-container">
            <mat-form-field
              appearance="fill"
              class="w-100 list-container primary-input bottom-zero padding-top-balance last rounded pointer-cursor"
            >
              <div
                class="d-flex justify-content-between list-box"
                (click)="navigateToPhysicalCredentials()"
              >
                <div class="title pl-1">
                  <img class="mr-2" [src]="FORM_ICONS.PHYSICAL_CREDENTIALS" />
                  {{ "PHYSICAL_CREDENTIALS" | translate }}
                </div>
                <div class="selected-value ml-auto text-right">
                  <p>
                    {{ formInstance?.cardCredential?.value }}
                  </p>
                </div>
                <div class="btn-list">
                  <button
                    mat-icon-button
                    type="button"
                    aria-label="phone"
                    class="text-right"
                    tabindex="-1"
                  >
                    <mat-icon>arrow_forward_ios</mat-icon>
                  </button>
                </div>
              </div>
              <input
                matInput
                [placeholder]="'PHYSICAL_CREDENTIALS' | translate"
                formControlName="cardCredential"
                class="d-none"
              />
            </mat-form-field>
          </div>
        </div>
        </ng-container>
      </form>
      <button *ngIf="hideAccessForUnassignedPendingAccess" type="button" class="assign-access-button" (click)="assignAccess()">
        {{ 'ASSIGN_ACCESS' | translate }}
      </button>
      <div *ngIf="!hideAccessForUnassignedPendingAccess" class="remove-user-action d-flex flex-row justify-content-center align-items-center">
        <ng-container
          *sameUserIdControl="{
            userId: profileDetails?.email,
            hide: true,
            hideSameAndLowerRoles: CONSTANTS.PROPERTY_MANAGER_USER,
            currentRole: profileDetails?.userType
          }"
        >
          <p
            class="remove-btn pointer-cursor mt-2 ml-2 pt-2 mb-3"
            (click)="removeFromUnit ? removeUserFromUnit() : removeUser()"
            type="button"
          >
            <img src="assets/svg/ico-close-circle-outline.svg" />
            {{
              (removeFromUnit
                ? "REMOVE_USER_FROM_UNIT_LABEL"
                : "REMOVE_USER_LABEL"
              ) | translate
            }}
          </p>
        </ng-container>
      </div>
    </div>
  </div>
</div>
